module.exports = __webpack_public_path__ + "img/assingment.40fef38d.svg";